import React, { useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../css/contact-quote.css';

const Quote = () => {
    const underlineRef = useRef(null);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (underlineRef.current) {
                underlineRef.current.classList.add('animate');
            }
        }, 50);

        return () => clearTimeout(timer);
    }, []);

    return (
        <div className="pcf">
            {/* Hero */}
            <header
                className="pcf-hero"
                style={{ backgroundImage: "url('/assets/quote.webp')" }}
            >
                <div className="container">
                    <span className="pcf-hero__eyebrow">
                        <i className="bi bi-file-earmark-text" /> Request
                    </span>
                    <h1 className="pcf-hero__title">Request a Quote</h1>
                    <p className="pcf-hero__subtitle">
                        Petrochoice Integrated Services — tell us what you need and our
                        team will come back with a scoped proposal.
                    </p>
                    <div className="pcf-rule" ref={underlineRef} />
                </div>
            </header>

            {/* Form */}
            <section className="pcf-section">
                <div className="container">
                    <div className="pcf-section-head">
                        <h2 className="pcf-section-title">Tell us about your project</h2>
                        <div className="pcf-rule animate" />
                        <p className="pcf-section-sub">
                            Share a few details and we&apos;ll get back to you as soon as possible.
                        </p>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-8 col-md-10">
                            <div className="pcf-card">
                                <div className="pcf-card__body">
                                    <form>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="pcf-field">
                                                    <label className="form-label" htmlFor="quote-name">
                                                        Your Name
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="quote-name"
                                                        name="name"
                                                        className="form-control"
                                                        placeholder="John Doe"
                                                        autoComplete="name"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="pcf-field">
                                                    <label className="form-label" htmlFor="quote-email">
                                                        Your Email
                                                    </label>
                                                    <input
                                                        type="email"
                                                        id="quote-email"
                                                        name="email"
                                                        className="form-control"
                                                        placeholder="example@email.com"
                                                        autoComplete="email"
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="pcf-field">
                                            <label className="form-label" htmlFor="quote-subject">
                                                Subject
                                            </label>
                                            <input
                                                type="text"
                                                id="quote-subject"
                                                name="subject"
                                                className="form-control"
                                                placeholder="Type your subject..."
                                            />
                                        </div>

                                        <div className="pcf-field">
                                            <label className="form-label" htmlFor="quote-message">
                                                Your Message
                                                <span className="pcf-opt">(optional)</span>
                                            </label>
                                            <textarea
                                                id="quote-message"
                                                name="message"
                                                className="form-control"
                                                rows="5"
                                                placeholder="Type your message..."
                                            />
                                        </div>

                                        {/* reCAPTCHA mounts here once a real site key is configured */}
                                        <div className="g-recaptcha" data-sitekey="YOUR_SITE_KEY" />

                                        <div className="pcf-actions">
                                            <button type="submit" className="pcf-btn pcf-btn--primary">
                                                <i className="bi bi-send" /> Submit Request
                                            </button>
                                            <button type="reset" className="pcf-btn pcf-btn--quiet">
                                                Reset
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Quote;
